<template>
    <div>
        <div v-for="(block, index) in getFieldValue" :key="block.id">
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <span v-on="on">{{ field.text + ' ' + (index+1) }}</span>
                </template>
                <span v-for="field in getFields(block)" :key="block.id + '-' + field.handle">
                    <dynamic-row
                            :item="block"
                            :field="field"
                            :show-label="true"
                    >
                    </dynamic-row>
                </span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>

  export default {
    props: {
      item: {
        type: Object
      },
      field: {
        type: Object,
        required: true
      }
    },
    methods: {
      getFields (block) {
        let fields = []
        for (let i in block) {
          if (block.hasOwnProperty(i) === true && i.includes('field_')) {
            fields.push(block[i])
          }
        }
        return fields
      }
    },
    computed: {
      getFieldValue () {
        if (this.item === null) {
          return ''
        }
        const field = this.item[this.field.handle]
        return field.value
      }
    },
    name: 'Matrix'
  }
</script>

<style scoped>

</style>